import { promoLinkCodeSchema } from "@reactive-resume/dto";

const STORAGE_KEY = "moncvpro.promo-link";

// Le code reste en attente jusqu'à la connexion et au choix du pays.
export const capturePromoLink = (search: string) => {
  const code = promoLinkCodeSchema.safeParse(new URLSearchParams(search).get("promo") ?? "");
  if (!code.success) return;

  try {
    localStorage.setItem(STORAGE_KEY, code.data);
  } catch {
    // Stockage indisponible (navigation privée) : le lien est ignoré.
  }
};

export const getPendingPromoLink = (): string | null => {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

export const clearPendingPromoLink = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Rien à nettoyer.
  }
};
